import { getLenis } from '@js/animations/Scroll'
import { reduceMotion } from '@js/animations/ReducedMotion'

const DESKTOP_MQ = '(min-width: 769px)'

const scrollToSectionTop = (section) => {
  const lenis = getLenis()

  if (lenis && !reduceMotion) {
    lenis.scrollTo(section)
    return
  }

  section.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' })
}

export class Timeline {
  constructor() {
    this.sections = document.querySelectorAll('.s-timeline[data-timeline-items]')
    if (!this.sections.length) {
      return
    }

    this.mediaQuery = window.matchMedia(DESKTOP_MQ)
    this.mediaQuery.addEventListener('change', () => this.initAll())
    this.initAll()
  }

  initAll() {
    this.sections.forEach((section) => {
      if (section._timelineCleanup) {
        section._timelineCleanup()
        section._timelineCleanup = null
      }

      this.initSection(section)
    })
  }

  initSection(section) {
    const itemCount = parseInt(section.dataset.timelineItems, 10) || 0
    if (!itemCount) {
      return
    }

    const railItems = section.querySelectorAll('.s-timeline__rail-item')
    const mediaSlides = section.querySelectorAll('.s-timeline__media-slide')
    const panelSlides = section.querySelectorAll('.s-timeline__panel-slide')

    const setActive = (index) => {
      const activeIndex = Math.max(0, Math.min(index, itemCount - 1))

      railItems.forEach((el, i) => {
        const isActive = i === activeIndex
        el.classList.toggle('s-timeline__rail-item--is-active', isActive)
        el.querySelector('.s-timeline__rail-trigger')?.setAttribute(
          'aria-current',
          isActive ? 'step' : 'false',
        )
      })

      mediaSlides.forEach((el, i) => {
        const isActive = i === activeIndex
        el.classList.toggle('s-timeline__media-slide--is-active', isActive)
        el.hidden = !isActive
      })

      panelSlides.forEach((el, i) => {
        const isActive = i === activeIndex
        el.classList.toggle('s-timeline__panel-slide--is-active', isActive)
        el.hidden = !isActive
      })
    }

    setActive(0)

    if (!this.mediaQuery.matches) {
      section.classList.add('s-timeline--static')
      return
    }

    section.classList.remove('s-timeline--static')

    const listeners = []

    railItems.forEach((item, index) => {
      const trigger = item.querySelector('.s-timeline__rail-trigger')
      if (!trigger) {
        return
      }

      const onClick = () => {
        setActive(index)
        scrollToSectionTop(section)
      }
      trigger.addEventListener('click', onClick)
      listeners.push(() => trigger.removeEventListener('click', onClick))
    })

    section._timelineCleanup = () => {
      listeners.forEach((remove) => remove())
    }
  }
}
